import React from 'react';
import styled from 'styled-components';
import { useTranslation, Trans } from 'react-i18next';
import CloseIcon from '@material-ui/icons/Close';

import VideoCall from 'components/icons/VideoCall';

const InfoModal = styled.div<{isDesktop: boolean}>`
  position: relative;
  border-radius: 10px;
  display: block;
  overflow: auto;
  background-color: #FFF;
  border: 3px solid #000;
  width: ${({ isDesktop }) => (isDesktop ? '650px' : '90%')};
  max-width: ${({ isDesktop }) => (isDesktop ? '650px' : '90%')};
  padding: ${({ isDesktop }) => (isDesktop ? '25px 40px' : '25px 30px')};
  max-height: 90%;
`;

const ModalClose = styled.div`
  position: absolute;
  padding: 5px;
  top: 10px;
  right: 10px;
  cursor: pointer;
`;

const TitleContainer = styled.div`
  font-size: 24px;
`;

const TextContainer = styled.div`
  margin-left: 20px;
`;

const InfoContent = ({
  handleClose,
  isDesktop = true,
}: {
  handleClose(): void;
  isDesktop: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <InfoModal isDesktop={isDesktop}>
      <ModalClose>
        <CloseIcon onClick={handleClose} />
      </ModalClose>
      <h2 id="modal-title">{t('booth.video_call', 'Video Call')}</h2>
      <p id="modal-description">
        <TitleContainer>
          {t(
            'booth.video_call_info.create_call.title',
            'Create a booth video call:',
          )}
        </TitleContainer>
      </p>
      <TextContainer>
        <p>
          <Trans
            i18nKey="booth.video_call_info.create_call.first"
            components={{ b: <b />, img: <VideoCall width={24} height={22} color="#ff0000" /> }}
            defaults="1. To create a booth video call, click on the <b>[<img />]</b> button."
          />
        </p>
        <p>
          <Trans
            i18nKey="booth.video_call_info.create_call.second"
            components={{ b: <b /> }}
            defaults="2. <b>[Accept]</b> and <b>[Decline]</b> options are available to all online Representatives."
          />
        </p>
        <p>
          {t(
            'booth.video_call_info.create_call.third',
            '3. Video call starts after any Representative accepted the call.',
          )}
        </p>
      </TextContainer>
      <p id="modal-description">
        <TitleContainer>
          {t(
            'booth.video_call_info.join_call.title',
            'Join an ongoing video call:',
          )}
        </TitleContainer>
      </p>
      <TextContainer>
        <p>
          <Trans
            i18nKey="booth.video_call_info.join_call.first"
            components={{ b: <b />, img: <VideoCall width={24} height={22} color="#ff0000" /> }}
            defaults="1. To join an ongoing video call, click on the <b>[<img />]</b> button."
          />
        </p>
        <p>
          <Trans
            i18nKey="booth.video_call_info.join_call.second"
            components={{ b: <b /> }}
            defaults="2. To admit or decline participant(s), <b>[Accept]</b> and <b>[Decline]</b> options are available to all Representatives."
          />
        </p>
      </TextContainer>
    </InfoModal>
  );
};

export default InfoContent;
